import { z } from "zod";
export const DTODiffCountBase = z.object({
    created: z.number(),
    updated: z.number(),
    deleted: z.number(),
});
export const DTODesignElementsDataDiffResponse = z.object({
    tokens: DTODiffCountBase,
    assets: DTODiffCountBase,
});
